import React, { useEffect, useRef } from "react";
import BaseModel from "../../models/BaseModel";
import NavigationTreeNode from "./NavigationTreeNode";
import { treeViewNodeId } from ".";
import TreeNodeInfo from "../../models/TreeNodeInfo";
import { useOnChangeWatcher } from "../../models/useOnChangeWatcher";
import { TreeContext } from "./TreeContext";
import { allignColumnTreeview } from "../../modelViews/GraficElementUtils";
import type { NavigatorNode } from "./NavigatorModel";
import Browser from "../../browser";

/** Reveals the omitted siblings without changing the current object selection. */
function NavigatorBreak({ node }: { node: NavigatorNode }) {
  return (
    <li className="navigatorBreakRow">
      <button type="button" className="navigatorBreak" title="Ausgelassene Einträge anzeigen" aria-label="Ausgelassene Einträge anzeigen"
        onKeyDown={event => event.stopPropagation()}
        onClick={event => { event.stopPropagation(); node.setExpanded(true); }} />
    </li>
  );
}

export default function NavigationTreeNodes(props: {
  parent: BaseModel;
  nesting: number;
  parentNodeInfo: TreeNodeInfo;
  treeContext: TreeContext;
  flyoutMenus: boolean
  navigatorNode?: NavigatorNode;
}) {
  const { treeContext, nesting, parent, parentNodeInfo, flyoutMenus } = props;
  const navigatorNode = props.navigatorNode;
  useOnChangeWatcher(navigatorNode);
  useOnChangeWatcher(navigatorNode?.parentNode);

  const ulRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    allignAllColumns(parent, ulRef.current);
  });

  useOnChangeWatcher(state.uiMode);

  useOnChangeWatcher(parent, (changedProperty, changedObject) => {
    if (!changedProperty || changedProperty == "childCollection") {
      return true;
    }
    return false;
  });

  if (!parentNodeInfo.obj.treeViewModel.isFolder) {
    return null;
  }

  let nodes = navigatorNode ? navigatorNode.visibleChildren.map(child => child.info) : parentNodeInfo.obj.treeViewModel.getChildCollectionEx(parentNodeInfo);

  //
  // Append deleted Objects
  //
  if (!navigatorNode && (state.showModifiedStatus || globalThis.compareState)) {
    if (!nodes) {
      nodes = new Array<TreeNodeInfo>();
    }
    const deletedChildCollection = parentNodeInfo.obj.treeViewModel.deletedChildCollection;
    deletedChildCollection.forEach((item) => {
      nodes?.push(new TreeNodeInfo(parentNodeInfo, item));
    });

    const newInOtherChildCollection = parentNodeInfo.obj.treeViewModel.newInOtherChildCollection;
    newInOtherChildCollection.forEach((item) => {
      nodes?.push(new TreeNodeInfo(parentNodeInfo, item));
    });
  }

  if (!nodes) {
    return null;
  }

  const nodeElements: any = [];
  nodes.forEach((node, index) => {
    const child = navigatorNode?.visibleChildren[index];
    if (navigatorNode && child?.hasHiddenPredecessor) {
      nodeElements.push(<NavigatorBreak key={`break-${child.id}`} node={navigatorNode} />);
    }
    nodeElements.push(
      <NavigationTreeNode
        key={navigatorNode?.visibleChildren[index].id ?? node.obj.id}
        navigatorNode={navigatorNode?.visibleChildren[index]}
        nesting={nesting + 1}
        node={node}
        parentNodeInfo={parentNodeInfo}
        treeContext={treeContext}
        allignAllColumns={allignAllColumns}
        flyoutMenus={flyoutMenus}
      />,
    );
  });
  if (navigatorNode?.hasHiddenSuccessors && !navigatorNode.parentNode?.hasHiddenSuccessors) {
    nodeElements.push(<NavigatorBreak key="trailing-break" node={navigatorNode} />);
  }

  // logger.log(`mwe1 render NavigationTreeNodes ${parent.name} ${nodes.length}`);

  function allignAllColumns(parentObj: BaseModel, root?: HTMLElement | null) {

    root ||= ulRef.current;
    if (root) {
      let maxWidths = 200;

      try {
        maxWidths = parentObj?.treeViewModel?.maxChildColumnSizes[nesting + 1] || 200;
      } catch (ex) {}

      allignColumnTreeview(`navTag-${nesting + 1}`, root, maxWidths);

      // for (let i = 1; i <= 10; i++) {
      //   allignColumnTreeview(`nav_C${i}`, root, 500);
      // }

      let found = false;
      for (let i = 10; i >= 1; i--) {
        try {
          maxWidths = parentObj?.treeViewModel?.maxChildColumnSizes[i] || 200;
        } catch (ex) {}
        const f = allignColumnTreeview(`nav_C${i}`, root, found ? maxWidths : 500);
        found ||= f;
      }

      //
      // only relevant for commander
      //
      const commander = root.closest(".commander");
      if (commander) {
        allignColumnTreeview("dataline", root); // no itx
      }
    }
  }

  const key = "ch-" + treeViewNodeId(treeContext?.treename, parent.id); // no itx
  // Skip the 32px expand control so breaks start at the child row's icon column.
const breakStyle = {
  "--navigator-break-indent": `${nesting * (Browser.isMobile() ? 5 : 10) + 32}px`,
} as React.CSSProperties;

  return (
    <ul ref={ulRef} key={key} style={breakStyle} className="nested">
      {nodeElements}
    </ul>
  );
}
6;
